import React from 'react';
import {twMerge} from 'tailwind-merge';

interface Props {
    id: string;
    buttonClassNames?: string;
    rootClassNames?: string;
}

export const AIGenLink: React.FC<Props> = ({id, buttonClassNames, rootClassNames}) => {
    return (
        <a
            href={`/aigen?docId=${id}`}
            className={twMerge(
                "relative inline-flex h-10 w-auto overflow-hidden rounded-lg p-px font-['Inter'] text-[16px] font-semibold",
                rootClassNames
            )}
        >
            <span
                className={`absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#dc2626_0%,#a855f7_50%,#dc2626_100%)]`}
            />
            <span
                className={twMerge(
                    'inline-flex h-full w-full cursor-pointer items-center justify-center rounded-lg bg-indigo-900/80 px-6 py-1 text-white backdrop-blur-3xl hover:bg-indigo-900/70',
                    buttonClassNames
                )}
            >
                AI Components (Alpha)
            </span>
        </a>
    );
};
